var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWedgeActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 31,
    viewBox: "0 0 27 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.58 0L26.2335 1.25723L25.5999 2.59474L24.228 3.77455L12.1517 29.2417C11.9195 29.7334 11.4722 30.0903 10.9418 30.2079C7.99299 30.8616 4.94525 30.9404 1.96632 30.443C0.879685 30.2609 0.0654253 29.3492 0.00808309 28.2482C-0.0764967 26.6211 0.505527 25.0313 1.62083 23.8429C1.89894 23.5476 2.31181 23.4157 2.71033 23.496C5.85556 24.1339 8.84882 25.3668 11.531 27.1257L22.902 3.14522L22.9464 1.33751L23.58 0Z",
    fill: "#006AB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWedgeActiveIcon);
export default __webpack_public_path__ + "static/media/wedgeActiveIcon.6a5d9efa7f68a858284fd06d87ba91d9.svg";
export { ForwardRef as ReactComponent };